import i18n from "../../i18n/index";
import orderList from "../order-grid/OrderList.vue";
import userAppService from "../../services/users-app/usersAppService";
import dayjs from "dayjs";

export default {
  data: () => ({
    headers: [
      {
        text: "TIPO DE DOCUMENTO",
        sortable: false,
        value: "idIdentificationType.code",
      },
      {
        text: "DOCUMENTO",
        sortable: false,
        value: "identification",
      },
      {
        text: "NOMBRE",
        value: "name",
        sortable: false,
      },
      {
        text: "FECHA SOLICITUD",
        value: "createdAt",
        sortable: false,
      },
      {
        text: "ESTADO",
        value: "status",
        sortable: false,
      },
    ],
    headersALL: [
      {
        text: "TIPO DE DOCUMENTO",
        sortable: false,
        value: "idIdentificationType.code",
      },
      {
        text: "DOCUMENTO",
        sortable: false,
        value: "identification",
      },
      {
        text: "NOMBRE",
        value: "name",
        sortable: false,
      },
      {
        text: "FECHA SOLICITUD",
        value: "createdAt",
        sortable: false,
      },
      {
        text: "ESTADO",
        value: "status",
        sortable: false,
      },
    ],
    tempUsers: [],
    tempUsersALL: [],
    loading: false,
    totalTempUsers: 0,
    pagination: {},
    loadingALL: false,
    totalTempUsersALL: 0,
    paginationALL: {},
    searchIdentification: "",
    searchIdentificationALL: "",
    handlingUser: false,
    loadingSave: false,
    loadingDeny: false,
    userAppTemp: {
      id: "",
      name: "",
      identification: "",
      identificationType: "",
      email: "",
      dateRequest: "",
      image: "",
    },
  }),

  created() {},
  watch: {
    pagination: {
      handler() {
        this.getTempUsers();
      },
      deep: true,
    },
  },
  methods: {
    async getTempUsers() {
      try {
        const { page, rowsPerPage } = this.pagination;
        this.loading = true;
        const response = await userAppService.searchTemporal(
          this.searchIdentification,
          page - 1,
          rowsPerPage
        );
        this.tempUsers = response.data[0];
        this.tempUsers.map((user) => {
          user.createdAt = dayjs(user.createdAt).format("YYYY-MM-DD");
        });
        this.totalTempUsers = response.data[1];
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    async getTempUsersALL() {
      try {
        const { page, rowsPerPage } = this.paginationALL;
        this.loadingALL = true;
        const response = await userAppService.searchTemporalALL(
          this.searchIdentificationALL,
          page - 1,
          rowsPerPage
        );
        this.tempUsersALL = response.data[0];
        this.tempUsersALL.map((user) => {
          user.createdAt = dayjs(user.createdAt).format("YYYY-MM-DD");
        });
        console.log(this.tempUsersALL);
        this.totalTempUsersALL = response.data[1];
        this.loadingALL = false;
      } catch (error) {
        this.loadingALL = false;
        console.log(error);
      }
    },
    async handleUser(user) {
      this.handlingUser = true;
      const arrFront = new Uint8Array(user.imageIdentificationFront.data);
      const arrBack = new Uint8Array(user.imageIdentificationBack.data);
      let typeString = "";
      console.log("x1 user", user);
      switch (user.fileTypeFront) {
        case "jpg":
          typeString = "image/jpeg";
          break;
        case "jpeg":
          typeString = "image/jpeg";
          break;
        case "png":
          typeString = "image/png";
          break;
        case "pdf":
          typeString = "application/pdf";
          break;
        default:
          break;
      }
      const blobFront = new Blob([arrFront], { type: typeString });
      let fileURLFront = window.URL.createObjectURL(blobFront);
      const blobBack = new Blob([arrBack], { type: typeString });
      let fileURLBack = window.URL.createObjectURL(blobBack);
      this.userAppTemp = {
        id: user.id,
        name: user.name,
        identification: user.identification,
        identificationType: user.idIdentificationType.code,
        email: user.email,
        requestDate: user.createdAt,
        imageFront: fileURLFront,
        imageBack: fileURLBack,
      };
    },
    async validate() {
      try {
        this.loadingSave = true;
        const response = await userAppService.approveTemporal({
          id: this.userAppTemp.id,
        });
        this.loadingSave = false;
        this.$notify({
          group: "app",
          type: "success",
          text: "Usuario validado correctamente",
        });
        this.close(true);
      } catch (error) {
        this.loadingSave = false;
        this.$notify({
          group: "app",
          type: "error",
          text: "Hubo un error validando el usuario",
        });
      }
    },
    async deny() {
      try {
        this.loadingDeny = true;
        const response = await userAppService.denyTemporal({
          id: this.userAppTemp.id,
        });
        this.loadingDeny = false;
        this.$notify({
          group: "app",
          type: "success",
          text: "Usuario rechazado correctamente",
        });
        this.close(true);
      } catch (error) {
        this.loadingDeny = false;
        this.$notify({
          group: "app",
          type: "error",
          text: "Hubo un error rechazando el usuario",
        });
      }
    },
    async close(refresh) {
      this.userAppTemp = {
        id: "",
        name: "",
        identification: "",
        identificationType: "",
        email: "",
        requestDate: "",
        image: "",
      };
      this.handlingUser = false;
      if (refresh) {
        this.getTempUsers();
      }
    },
  },
};
